import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { X, Radio } from "lucide-react";
import { useAuth } from "@/lib/auth.jsx";

const weekKey = () => {
  const d = new Date();
  const onejan = new Date(d.getFullYear(), 0, 1);
  const week = Math.ceil(((d - onejan) / 86400000 + onejan.getDay() + 1) / 7);
  return `${d.getFullYear()}-W${week}`;
};

export default function CoachNudge() {
  const { user } = useAuth();
  const [nudge, setNudge] = useState(null);

  useEffect(() => {
    if (!user?.is_premium) return;
    if (localStorage.getItem("ihmj_coach_nudge_dismissed") === weekKey()) return;
    api.get("/coach/nudge").then(r => { if (r.data.show) setNudge(r.data); }).catch(()=>{});
  }, [user?.is_premium]);

  if (!nudge) return null;

  const n = user?.name ? `${user.name}, ` : "";
  const message = nudge.kind === "first_voice"
    ? `${n}try a two minute hands-free chat with your coach. Just talk, it talks back.`
    : `${n}it's been about a week. Do a quick hands-free check-in with your coach and lock in this week's move.`;

  const dismiss = () => {
    localStorage.setItem("ihmj_coach_nudge_dismissed", weekKey());
    setNudge(null);
  };

  return (
    <div className="mt-5 card-panel-elevated p-3 sm:p-4 border-[#FD0F10]/40" data-testid="coach-nudge">
      <div className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-full bg-[#FD0F10]/15 border border-[#FD0F10]/40 flex items-center justify-center shrink-0 text-[#FD0F10]">
          <Radio size={18} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="eyebrow text-[#FD0F10] hidden sm:block">YOUR COACH</div>
          <p className="text-xs sm:text-sm text-gray-100 sm:mt-1 leading-snug">{message}</p>
        </div>
        <Link to="/coach" className="shrink-0 hero-accent text-white text-[11px] sm:text-xs font-mono-ui uppercase tracking-wider px-3 py-2 rounded" data-testid="coach-nudge-talk">
          Talk
        </Link>
        <button onClick={dismiss} className="text-gray-400 hover:text-white shrink-0 p-1 -mr-1" aria-label="Dismiss" data-testid="coach-nudge-dismiss">
          <X size={18} />
        </button>
      </div>
    </div>
  );
}
